import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'

class ModalDeleteItem extends Component {
  render () {
    return (
      <Modal
        width='580'
        effect='fadeInUp'
        visible={(this.props.show)}
      >
        <Fragment>
          <div
            className='col-12 border-bottom-lg border-color-featured bg-white pt-3 pb-1 mr-auto ml-auto'
          >
            <div className='row px-3 border-color-ui-3 border-bottom pb-2'>
              <div className='col-11'>
                <h3 id='modalTitle'>Excluir celular</h3>
              </div>
            </div>
            <div className='col-12'>
              <div className='row'>
                <div className='col-12 mt-3'>
                  <div className='row mx-1'>
                    <div className='col-12 row modal-scroll color-ui-2 txt-font-body txt-body-sm product-rating mx-0'>
                      <p className='col-12 txt-body-sm pb-2 px-0'>
                        Deseja excluir o celular cadastrado?
                      </p>
                      <div className='col-12 col-md-6 row my-2'>
                        <Button
                          id={'btn-close-sms-verification'}
                          name={'btn-close-sms-verification'}
                          className='btn btn-double btn-featured btn-rating-modal col-12'
                          text='Cancelar'
                          onClick={this.props.onClose}
                        />
                      </div>
                      <div className='col-12 col-md-6 row my-2 ml-3'>
                        <Button
                          id={'btn-send-sms-verification'}
                          name={'btn-send-sms-verification'}
                          className='btn btn-double btn-featured btn-rating-modal2 col-12'
                          text='Confirmar'
                          onClick={this.props.onCloseButton}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </Modal>
    )
  }
}

ModalDeleteItem.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.bool,
  onCloseButton: PropTypes.bool
}

export default ModalDeleteItem



// WEBPACK FOOTER //
// ./src/Participant/TwoStepVerification/ModalDeleteItem/ModalDeleteItem.js